export default __webpack_public_path__ + "static/media/slider-img0.9fe036b6.gif";